<template>
  <nna-container>
    <div class="notices-page" v-html="body"></div>
  </nna-container>
</template>

<script>
export default {
  name: 'NoticesPage',
  data() {
    return {
    }
  },
  props: {       
  },
  computed: {
    body() {
      return this.$route.params.body ? this.$route.params.body : ''
    }
  },
  methods: {    
  },
  mounted() {
    
  }
}
</script>

<style scoped>  
</style>


// WEBPACK FOOTER //
// src/modules/common/components/notices/noticesPage.vue